var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgeur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 257c70.692 0 128-57.308 128-128C257 58.308 199.692 1 129 1 58.308 1 1 58.307 1 129c0 70.692 57.307 128 128 128Z",
    fill: "url(#a)",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 106.049 129 20.2l86.4 85.849-42.396 42.125-43.173-42.898-.776-.771-.778.771-43.2 42.924L42.6 106.049Z",
    fill: "#FFF6F0",
    stroke: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.697 161.64h33.945v9.677H71.834v12.288h22.887v9.676H71.834v12.442h24.73v9.677H61.697v-53.76Zm83.582 0v35.174c0 6.144-1.639 10.957-4.916 14.439-3.225 3.481-8.038 5.222-14.438 5.222s-11.238-1.741-14.515-5.222c-3.226-3.482-4.839-8.295-4.839-14.439V161.64h10.138v35.174c0 3.175.742 5.658 2.227 7.45 1.485 1.792 3.815 2.688 6.989 2.688s5.504-.896 6.989-2.688c1.485-1.792 2.227-4.275 2.227-7.45V161.64h10.138Zm45.872 53.76h-10.137v-16.128c0-1.229-.333-2.227-.999-2.995-.614-.768-1.664-1.152-3.148-1.152h-11.674V215.4h-10.138v-53.76h20.583c2.765 0 5.197.384 7.296 1.152 2.099.768 3.84 1.843 5.222 3.225a12.827 12.827 0 0 1 3.226 4.685c.768 1.792 1.152 3.712 1.152 5.76v1.843c0 2.202-.589 4.276-1.767 6.221-1.177 1.895-2.995 3.354-5.452 4.378v1.382c1.792.205 3.2.896 4.224 2.074 1.075 1.177 1.612 2.662 1.612 4.454V215.4Zm-25.958-29.952h9.677c2.457 0 4.326-.563 5.606-1.69 1.28-1.177 1.92-2.816 1.92-4.915v-.922c0-1.792-.64-3.328-1.92-4.608-1.28-1.331-3.149-1.996-5.606-1.996h-9.677v14.131Z",
    fill: "#2A363A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 129,
    y1: 1,
    x2: 129,
    y2: 257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCEAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeur);
export default __webpack_public_path__ + "static/media/ageur.27bb163edde7630fc571c0a3a9bb4508.svg";
export { ForwardRef as ReactComponent };